import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import ProductCategory from '@/repositories/data/webshop/ProductCategory';

export default class ProductCategoryRepository extends BaseCrudRepository<number, ProductCategory, ProductCategory> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product-category/');
    }
}
